import { ExecutionStates, EnrollmentStates } from 'automation-ui-log-events/constants/LogEventConstants';
export const UnknownTypeKey = 'UNKNOWN';
export const NonspecificTypeKey = 'ANY';
export const DetailedPropertiesTypeKey = 'DETAILED_PROPERTIES';
export const NonspecificActionTypeExecutionStates = [ExecutionStates.SKIPPED, ExecutionStates.FAIL_RESCHEDULE];
export const NonspecificActionTypeErrorTypes = ['RETRY_ACTION_EXCEEDED_MAX_TIME'];
export const NonspecificEnrollTypeEnrollmentStates = [EnrollmentStates.FAILED];
export const MissingPropertyErrorTypes = ['REQUIRED_PROPERTIES_MISSING'];
export const ManualEnrollTriggerTypes = {
  INTEGRATION: 'INTEGRATION'
};
export const FieldKeys = {
  DEFAULT: 'default',
  DETAILS: 'details',
  ENROLLMENT_ATTEMPT: 'enrollmentAttempt',
  ENROLLMENT_RESULT: 'enrollmentResult',
  FAILURE: 'failure',
  FOR_MORE: 'forMore',
  DETAILED_PROPERTIES: 'detailedProperties'
};